import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';
import { LayoutService } from '../layouts/services/layout.service';

export const connectivityInterceptor: HttpInterceptorFn = (req, next) => {
  const layoutService = inject(LayoutService);

  return next(req).pipe(
    tap(() => {
      if (layoutService.isOffline()) {
        layoutService.setOffline(false);
      }
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 0) {
        layoutService.setOffline(true);
      }
      return throwError(() => error);
    })
  );
};
